import { Injectable } from "@angular/core";
import { BaseStyle } from "primeng/base";

@Injectable({ providedIn: "root" })
export class SidenavPanelStyle extends BaseStyle {
  override name = "sidenavpanel";

  override classes = {
    root: "ui-sidenavpanel",
    active: "ui-sidenavpanel-active",
  };
}
